import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListCommentCell } from './token-list-comment.cell';
import { TokenListCommentHeader } from './token-list-comment.header';

export const TokenListCommentColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['comment']
> = {
  enableSorting: false,
  header: TokenListCommentHeader,
  cell: TokenListCommentCell,
};
